
<template>
    <!-- 驼户和服务人员的订单明细列表 -->
    <div class="each-tuohu-record" v-if="type == 1">
        <div class="top">
            <div class="t-left">
                <img :src="list1Src" class="title-icon">
                <span class="instinct-title">门票游玩</span>
            </div>
            <div class="t-right">订单编号：{{item.orderNo}}</div>
        </div>
        <div class="bottom">
            <img class="preview" :src="camelImageSrc" alt>
            <div class="detail-wra">
                <div class="row1 text-overflow" v-text="ticketName"></div>
                <div class="row2">
                    结算金额：
                    <span class="price">{{item.settlementFee || 0}}</span>
                </div>
                <div class="row3">
                    <span class="time">{{item.finishTime}}完成</span>
                </div>
            </div>
        </div>
    </div>
    <div class="each-record" v-else-if="type == 2">
        <div class="left-zone">
            <span class="price">+ {{item.settlementMoney || item.settlementFee}}</span>
        </div>
        <div class="rignt-zone">
            <div class="time" v-text="item.finishTime || item.addTime"></div>
            <div class="t">明细</div>
        </div>
    </div>
    <div class="each-record" v-else-if="type == 3">
        <div class="left-zone">
            <img class="gold" :src="goldSrc" alt="gold">
            <span class="price">+ {{item.settlementMoney || item.settlementFee}}</span>
        </div>
        <div class="rignt-zone">
            <div class="time" v-text="item.finishTime || item.addTime"></div>
            <div class="t amount">结算金额</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ListOfRecord",
    // inheritAttrs: false,
    props: {
        item: Object,
        hasIcon: {
            default: true,
            type: Boolean
        },
        type: [String, Number]
    },
    data() {
        return {
            list1Src: "",
            camelImageSrc: "",
            goldSrc: ""
        };
    },
    computed: {
        ticketName() {
            if (!this.item.productName) return "";
            return this.item.specsName
                ? `${this.item.productName}（${this.item.specsName}）`
                : `${this.item.productName}`;
        }
    },
    watch: {},
    created() {},
    mounted() {
        this.list1Src = API.ossUrl + "user/svg/list-1.svg";
        this.camelImageSrc = API.ossUrl + "yyq/camel-image.png";
        this.goldSrc = API.ossUrl + "user/png/gold.png";
    },
    destroyed() {},
    methods: {}
};
</script>


<style scoped lang="scss">
.each-record {
    padding: 0.373333rem 0;
    border-bottom: 1px solid #ebebeb;
    display: flex;
    justify-content: space-between;
    .left-zone {
        display: flex;
        align-items: center;
        .gold {
            margin-right: 6px;
            display: inline-block;
        }
        .icon {
            width: 0.533333rem;
            height: 0.533333rem;
            margin-right: 0.133333rem;
        }
        .price {
            font-size: 18px;
            color: #f0bb1b;
        }
    }
    .rignt-zone {
        text-align: right;
        font-size: 14px;
        margin-top: 0.266667rem;
        margin-bottom: 0.266667rem;
        .time {
            color: #999999;
        }
        .t {
            color: #444444;
        }
        .amount {
            margin-top: 6px;
        }
    }
}
.each-tuohu-record {
    .top {
        width: 100%;
        height: 1.013333rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: $white;
        .t-left {
            display: flex;
            align-items: center;
            .title-icon {
                width: 0.426667rem;
                height: 0.426667rem;
                margin-right: 0.133333rem;
            }
            .instinct-title {
                color: #444;
                font-size: 0.426667rem;
            }
        }
        .t-right {
            color: #999;
            font-size: 0.32rem;
        }
    }
    .bottom {
        padding: 0.4rem 0;
        border-bottom: 1px solid #ebebeb;
        display: flex;
        .preview {
            margin-right: 0.266667rem;
            width: 2.133333rem;
            height: 2.133333rem;
            border-radius: 5px;
            flex: 1 0 auto;
        }
        .detail-wra {
            .row1 {
                color: #444444;
                font-size: 16px;
                margin-bottom: 0.2rem;
                width: 7.1rem;
            }
            .row2 {
                color: #444444;
                margin-bottom: 0.2rem;
                font-size: 16px;
                .price {
                    color: #f8b356;
                }
            }
            .row3 {
                color: #999999;
                font-size: 14px;
            }
        }
    }
}
</style>

